var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 12.332C17.5562 12.332 12.333 17.5552 12.333 23.9987C12.333 30.4422 17.5562 35.6654 23.9997 35.6654C30.4432 35.6654 35.6663 30.4422 35.6663 23.9987C35.6663 17.5552 30.4432 12.332 23.9997 12.332Z",
    stroke: "#6d4096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 31.4037C14.9805 31.4037 17.581 28.0833 23.9976 28.0833C30.4143 28.0833 33.016 31.4037 33.016 31.4037M23.9976 24C24.9259 24 25.8161 23.6313 26.4725 22.9749C27.1289 22.3185 27.4976 21.4283 27.4976 20.5C27.4976 19.5717 27.1289 18.6815 26.4725 18.0251C25.8161 17.3687 24.9259 17 23.9976 17C23.0694 17 22.1791 17.3687 21.5228 18.0251C20.8664 18.6815 20.4976 19.5717 20.4976 20.5C20.4976 21.4283 20.8664 22.3185 21.5228 22.9749C22.1791 23.6313 23.0694 24 23.9976 24Z",
    stroke: "#6d4096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfo);
export default __webpack_public_path__ + "static/media/user_info.4f93d7a07bc6ab7afbfd71901232e02e.svg";
export { ForwardRef as ReactComponent };